import { useMemo } from "react"

import { scaleShopifyImage } from "@app/utils/image"

export const useShopifyImage = (url: string, size: string) => {
  const scaledUrl = useMemo(() => scaleShopifyImage(url, size), [size, url])

  return { scaledUrl }
}
